import React from 'react';
import { Link } from 'react-router-dom';
import './NavDropdown.css';

function NavDropdown({ item, isActive, onHover, onClick, onLeave, currentPath, permissions }) {
  const shouldShowItem = (subItem) => {
    if (!subItem.requiresPermission) return true;
    return permissions[subItem.requiresPermission];
  };

  return (
    <div 
      className={`nav-dropdown ${isActive ? 'active' : ''}`}
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
    >
      <button 
        className={`nav-button dropdown-trigger ${currentPath.startsWith(item.path) ? 'active' : ''}`}
        onClick={onClick}
      >
        {item.label}
        <span className="dropdown-arrow">▼</span>
      </button>
      
      {/* This dropdown-menu div needs to be rendered */}
      <div className={`dropdown-menu ${isActive ? 'active' : ''}`}>
        {item.items?.map((subItem, index) => {
          if (!shouldShowItem(subItem)) return null;

          if (subItem.type === 'separator') {
            return (
              <div key={index} className="dropdown-separator">
                <div className="dropdown-separator-line" />
                {subItem.label && (
                  <span className="dropdown-separator-label">{subItem.label}</span>
                )}
              </div>
            );
          }

          if (subItem.type === 'nested') {
            return (
              <div key={index} className="dropdown-submenu">
                <div className="dropdown-submenu-label">
                  {subItem.label}
                  <span className="dropdown-submenu-arrow">›</span>
                </div>
                <div className="dropdown-submenu-items">
                  {subItem.items?.map((nestedItem) => (
                    <Link
                      key={nestedItem.path}
                      to={nestedItem.path}
                      className={`dropdown-submenu-item ${currentPath === nestedItem.path ? 'active' : ''}`}
                    >
                      {nestedItem.label}
                    </Link>
                  ))}
                </div>
              </div>
            );
          }
          
          return (
            <Link
              key={subItem.path}
              to={subItem.path}
              className={`dropdown-item ${currentPath === subItem.path ? 'active' : ''}`}
            >
              {subItem.label}
              {subItem.badge > 0 && (
                <span className="dropdown-item-badge">{subItem.badge}</span>
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default NavDropdown;